import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class SegmentService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getTitle = (): string => 'Segment';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'segment/0', 'title': 'Segment News', 'theme': 'layout1' },
      { 'url': 'segment/1', 'title': 'Segment List', 'theme': 'layout2' },
      { 'url': 'segment/2', 'title': 'Segment Cards', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): any => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'Segment List',
      'segmentButton1': 'new hotel',
      'segmentButton2': 'rooms',
      // Data Page 1
      'page1': {
        'headerImage': 'assets/imgs/background/7.jpg',
        'title': 'Park Hyatt Vienna',
        'category': 'Rooms',
        'shareIcon': 'ellipsis-vertical',
        'button': 'Book Now',
        'price': '$ 100',
        'priceTitle': 'per night',
        'description': "Hoc est, visu nova thriller, posuit orbem in fimbriis modern arte, quae est tenebrosa, haunting, torta - vertit se et in suo modo. Non quod objective, et arte discipulus apud Notingham, nuper Jack quae ducitur 'diluvium, ' frigus, saeva enfant inexpugnabiles omnes modern art. Et vadit ad deversorium cubiculum vult bibere et cetera id exuendum statum tunc illa e somno evigilans in lecto suo. Hoc est, visu nova thriller, posuit orbem in fimbriis modern arte, quae est tenebrosa, haunting, torta - vertit se et in suo modo. Non quod objective, et arte discipulus apud Notingham, nuper Jack quae ducitur 'diluvium, ' frigus, saeva enfant inexpugnabiles omnes modern art. Et vadit ad deversorium cubiculum vult bibere et cetera id exuendum statum tunc illa e somno evigilans in lecto suo.",
      },
      // Data Page 2
      'page2': {
        'items': [
          {
            'id': 1,
            'title': '45 Park Lane',
            'subtitle': '2 beds',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/8.jpg',
            'button': 'Book Now',

          },
          {
            'id': 2,
            'title': 'Encore Macau',
            'subtitle': '2 beds',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/9.jpg',
            'button': 'Book Now',
          },
          {
            'id': 3,
            'title': 'Bulgari Hotel London',
            'subtitle': '2 beds',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/6.jpg',
            'button': 'Book Now',
          },
          {
            'id': 4,
            'title': 'Belmond El Encanto',
            'subtitle': '2 beds',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/5.jpg',
            'button': 'Book Now',
          },
          {
            'id': 5,
            'title': 'The Allocationa Gstaad',
            'subtitle': '2 beds',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/7.jpg',
            'button': 'Book Now',
          },
        ]
      }
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Segment Card',
      'segmentButton1': 'List Hotels',
      'segmentButton2': 'List Pubs',
      'segmentButton3': 'List Restaurants',
      // Data Page 1
      'page1': {
        'items': [
          {
            'id': 1,
            "title": "New York Hilton Midtown",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/1.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 2,
            "title": "New York Marriott Marquis",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/2.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 3,
            "title": "Grand Hyatt New York",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/3.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 4,
            "title": "The Roosevelt Hotel",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/4.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 5,
            "title": "Kennedy Fried Chicken",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/9.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 6,
            "title": "PKorilla BBQ",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/10.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 7,
            "title": "BurritoVille",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/11.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 8,
            "title": "Mo Gridder's",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/12.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          }
        ]
      },
      // Data Page 2
      'page2': {
        'items': [
          {
            'id': 1,
            "title": "O’Donnell’s Pub",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/8.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 2,
            "title": "4th Avenue Pub",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/7.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 3,
            "title": "Perdition",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/6.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 4,
            "title": "John Sullivan’s",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/5.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 5,
            "title": "Mo Gridder's",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/12.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 6,
            "title": "BurritoVille",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/11.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 7,
            "title": "PKorilla BBQ",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/10.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 8,
            "title": "Kennedy Fried Chicken",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/9.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          }
        ]
      },
      // Data Page 2
      'page3': {
        'items': [
          {
            'id': 1,
            "title": "Ugly Baby",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/9.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 2,
            "title": "Crown Shy",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/11.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 3,
            "title": "Superiority Burger",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/10.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 4,
            "title": "Via Carota",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/12.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 5,
            "title": "Usha Foods",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/8.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 6,
            "title": "Don Angie",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/11.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 7,
            "title": "Dirt Candy",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/10.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          },
          {
            'id': 8,
            "title": "Maison Yaki",
            "description": "Amazing New Place",
            "image": "assets/imgs/avatar/9.jpg",
            "details": "Main Street 32, NYC",
            "icon": "location",
          }
        ]
      }
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Segment Post',
      'segmentButton1': 'Favorites',
      'segmentButton2': 'Last watched',
      // Data Page 1
      'page1': {
        'items': [
          {
            'id': 1,
            'title': '45 Park Lane',
            'subtitle': '7 km to center',
            'price': '$ 20 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/5.jpg',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
          {
            'id': 2,
            'title': 'Encore Macau',
            'subtitle': '3 km to center',
            'price': '$ 700 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/6.jpg',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
          {
            'id': 3,
            'title': 'Bulgari Hotel London',
            'subtitle': '30 km to center',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/7.jpg',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
          {
            'id': 4,
            'title': 'Belmond El Encanto',
            'subtitle': '22 km to center',
            'price': '$ 500 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/8.jpg',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
        ]
      },
      // Data Page 2
      'page2': {
        'items': [
          {
            'id': 1,
            'title': 'Nobu Ryokan Malibu',
            'subtitle': '9 km to center',
            'price': '$ 20 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/9.jpg',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
          {
            'id': 2,
            'title': 'Mandarin Oriental, Milan',
            'subtitle': '4 km to center',
            'price': '$ 700 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/6.jpg',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          },
          {
            'id': 3,
            'title': 'Palace Hotel Tokyo',
            'subtitle': '10 km to center',
            'price': '$ 300 per month',
            'available': 'Available Now',
            'image': 'assets/imgs/background/8.jpg',
            "iconsStars": [
              {
                "icon": "star",
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star"
              },
              {
                "icon": "star-outline"
              }
            ],
          }
        ]
      }
    };
  }

  load(item: any): Observable<any> {
    this.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('segment/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            this.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            this.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        this.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
